
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "cargo-query-plan",
components:{Popup},
data(){
return{
show:true,
tabIndex:1,
wrapperHeight:0,
allLoaded:false,
config:{
title:'要货计划',
url:'api/requireGoodsOrder/page',
workflowSearchBean:{},
tabList:['查询要货计划单','计划明细表'],
property: "createdDate",
fixRules:{},
inputCondition:{
placeholder:'物料编号/名称',
searchCondition:'key',
rules:[{field:"requireGoodsOrderDts.matName-requireGoodsOrderDts.matCode", option: "LIKE_ANYWHERE",collectIndex:0}]
}
},
configTodo:{
title:'要货计划',
url:'api/requireGoodsPlanRow/page',
tabList:['查询要货计划单','计划明细表'],
property: "createdDate",
fixRules:{},
inputCondition:{
placeholder:'物料编号/名称',
searchCondition:'key',
rules:[{field:"requireGoodsOrderDts.matName-requireGoodsOrderDts.matCode", option: "LIKE_ANYWHERE",collectIndex:0}]
},
selectConfig:[
{
text:'计划类型',
type:'selector',
list:[{name:'全部',code:null},{name:'确定计划',code:'confirm'},{name:'参考计划',code:'plan'},{name:'默认计划',code:'_default'}],
rules:[{field: "planType",option: "EQ"}],
},
{
text:'状态',
type:'selector',
list:[{name:'全部',code:null},{name:'未确认',code:'unConfirm'},{name:'已确认',code:'confirm'}],
rules:[{field: "status",option: "IN"}],
},
{
text: '要货日期',
type: 'date',
isOld:true,
rules:[{field: "planCycle",collectIndex: -1,option: "BTD"}],
}
]
},
list:[],
popupShow:false,
showDetail:{}
}
},
methods:{
getTabIndex(e){
this.tabIndex = e;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
goCargoDetail(id){
this.$router.push('/cargo/view/'+ id);
},
viewDetail(item){
this.popupShow = true;
this.showDetail = item;
}
},
mounted(){
this.init();
this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
this.tabIndex = this.$route.query.tabIndex || 1;
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/cargo-query-plan.vue